// extracted by css-extract-rspack-plugin
export default {"headerRow":"SavedViews-module__headerRow__scfFl6y","savedViewsList":"SavedViews-module__savedViewsList__BNsFdBu"};